import { gql } from "@apollo/client";

export const INSERT_PMV_STATUS = gql`
    mutation INSERT_PMV_STATUS($message: String!, $pmv_id: Int!) {
        insert_its_pmv_statuses(objects: {message: $message, pmv_id: $pmv_id}) {
            returning {
            id
            message
            pmv_id
            created_at
            }
        }
    }
  `;